import { apiAxiosAuth } from 'services/api';
import { DataFormUserProps } from 'types/DataFormUserProps';
import { UserMondelezProps } from 'types/UserProps';
import { RolesTypes } from 'types/RolesTypes';

interface SaverUserResp {
	isSuccess: boolean;
	newUser: null | UserMondelezProps;
}

export async function saveUser(user: DataFormUserProps, handleNotify: any) {
	const resp: SaverUserResp = { isSuccess: false, newUser: null };

	const payload: any = {
		email: user.email || '',
		firstName: user.firstName || '',
		lastName: user.lastName || '',
		phone: user.phone || '',
		password: user.password || '',
		roleId: typeof user.typeUser === 'string' ? '' : user.typeUser.id
	};

	//cria o usuário
	await apiAxiosAuth
		.post('users', payload)
		.then((res) => {
			resp.isSuccess = true;
			resp.newUser = res.data;

			handleNotify('Usuário criado com sucesso', 'success');
		})
		.catch((error) => {
			resp.isSuccess = false;
			resp.newUser = null;

			handleNotify(
				error?.response?.data?.message ||
					error?.message ||
					'Ocorreu algum erro para criar o usuário',
				'error'
			);
		});

	// //associa ao usuário criado a role escohida
	// if (resp.isSuccess && resp.newUser !== null && user.typeUser !== '') {
	// 	await apiAxiosAuth
	// 		.post(`acl/assign/roles/${user.typeUser.id}/user/${resp.newUser.id}`)
	// 		.then(() => {})
	// 		.catch(() => {
	// 			handleNotify(
	// 				'Ocorreu algum erro ao associar a role do usuário',
	// 				'error'
	// 			);
	// 		});
	// }

	return resp;
}

//compara os campos do formulário com os dados do usuário original e retorna apenas os campos que foram alterados
export function getChangedFieldsPayload(
	userToEdit: any,
	dataUserForm: any,
	noChangePassword: string
) {
	const payload: any = {};

	// Campos que queremos verificar
	const fieldsToCheck: (keyof typeof dataUserForm)[] = [
		'email',
		'firstName',
		'lastName',
		'phone',
		'password'
	];

	fieldsToCheck.forEach((field) => {
		if (dataUserForm[field] !== userToEdit[field]) {
			payload[field] = dataUserForm[field];
		}
	});

	// Regra especial da senha
	if (
		dataUserForm.password === noChangePassword ||
		dataUserForm.passwordConfirm === noChangePassword
	) {
		delete payload.password;
	}

	// Verifica mudança da Role
	if (
		typeof dataUserForm.typeUser !== 'string' &&
		dataUserForm.typeUser?.id !== userToEdit.roleId
	) {
		payload.roleId = dataUserForm.typeUser.id;
	}

	return payload;
}

interface SaverUserResp {
	isSuccess: boolean;
	newUser: null | UserMondelezProps;
}

export async function editUser(
	userToEdit: UserMondelezProps,
	dataUserForm: DataFormUserProps,
	handleNotify: any,
	noChangePassword: string,
	listRoles: RolesTypes[]
) {
	const resp: SaverUserResp = { isSuccess: false, newUser: null };

	//compara os campos do formulário com os dados do usuário original e retorna apenas os campos que foram alterados
	const payload: any = getChangedFieldsPayload(
		userToEdit,
		dataUserForm,
		noChangePassword
	);

	if (
		dataUserForm.password === noChangePassword ||
		dataUserForm.passwordConfirm === noChangePassword
	) {
		delete payload?.password;
		delete payload?.passwordConfirmation;
	}

	//atualiza o usuário
	await apiAxiosAuth
		.patch(`users/${userToEdit.id}`, payload)
		.then((res) => {
			resp.isSuccess = true;
			resp.newUser = res.data;

			handleNotify('Usuário editado com sucesso', 'success');
		})
		.catch((error) => {
			resp.isSuccess = false;
			resp.newUser = null;

			handleNotify(
				error?.message || 'Ocorreu algum erro para editar o usuário',
				'error'
			);
		});

	// //associa ao usuário criado a role escohida
	// if (resp.isSuccess && resp.newUser !== null && dataUserForm.typeUser !== '') {
	// 	await apiAxiosAuth
	// 		.post(
	// 			`acl/assign/roles/${dataUserForm.typeUser.id}/user/${resp.newUser.id}`
	// 		)
	// 		.then(() => {})
	// 		.catch(() => {
	// 			handleNotify(
	// 				'Ocorreu algum erro ao associar a role do usuário',
	// 				'error'
	// 			);
	// 		});
	// }

	//deleta roles antigas do usuário
	if (resp.isSuccess && listRoles.length > 0) {
		const arrayIdsTypesRoleToDelete: { id: string; role: string }[] = [];

		if (arrayIdsTypesRoleToDelete.length > 0) {
			await Promise.all(
				arrayIdsTypesRoleToDelete.map(async (roleToDelete) => {
					try {
						await apiAxiosAuth.delete(
							`acl/assign/roles/${roleToDelete.id}/user/${resp.newUser?.id}`
						);
					} catch {
						handleNotify(
							'Ocorreu algum erro ao deletar a role do usuário',
							'error'
						);
					}
				})
			);
		}
	}

	return resp;
}

export async function editMyUser(
	userToEdit: UserMondelezProps,
	dataUserForm: DataFormUserProps,
	handleNotify: any,
	noChangePassword: string,
	listRoles: RolesTypes[]
) {
	const resp: SaverUserResp = { isSuccess: false, newUser: null };

	//compara os campos do formulário com os dados do usuário original e retorna apenas os campos que foram alterados
	const payload: any = getChangedFieldsPayload(
		userToEdit,
		dataUserForm,
		noChangePassword
	);

	if (
		dataUserForm.password === noChangePassword ||
		dataUserForm.passwordConfirm === noChangePassword
	) {
		delete payload?.password;
		delete payload?.passwordConfirmation;
	}

	delete payload.roleId;

	//atualiza o usuário
	await apiAxiosAuth
		.patch(`users/me`, payload)
		.then((res) => {
			resp.isSuccess = true;
			resp.newUser = res.data;

			handleNotify('Usuário editado com sucesso', 'success');
		})
		.catch((error) => {
			resp.isSuccess = false;
			resp.newUser = null;

			handleNotify(
				error?.message || 'Ocorreu algum erro para editar o usuário',
				'error'
			);
		});

	// //associa ao usuário criado a role escohida
	// if (resp.isSuccess && resp.newUser !== null && dataUserForm.typeUser !== '') {
	// 	await apiAxiosAuth
	// 		.post(
	// 			`acl/assign/roles/${dataUserForm.typeUser.id}/user/${resp.newUser.id}`
	// 		)
	// 		.then(() => {})
	// 		.catch(() => {
	// 			handleNotify(
	// 				'Ocorreu algum erro ao associar a role do usuário',
	// 				'error'
	// 			);
	// 		});
	// }

	//deleta roles antigas do usuário
	if (resp.isSuccess && listRoles.length > 0) {
		const arrayIdsTypesRoleToDelete: { id: string; role: string }[] = [];

		if (arrayIdsTypesRoleToDelete.length > 0) {
			await Promise.all(
				arrayIdsTypesRoleToDelete.map(async (roleToDelete) => {
					try {
						await apiAxiosAuth.delete(
							`acl/assign/roles/${roleToDelete.id}/user/${resp.newUser?.id}`
						);
					} catch {
						handleNotify(
							'Ocorreu algum erro ao deletar a role do usuário',
							'error'
						);
					}
				})
			);
		}
	}

	return resp;
}
